export default{
    data() {
        return {
            safariTrue:false
        }
    },
    methods:{
        convert(str) {
            if(!this.safariTrue){
                var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
                return [day, mnth,date.getFullYear()].join("/");
            }else{
                var date = new Date(str);
                return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
            }
        },
        display (seconds) {
            const format = val => `0${Math.floor(val)}`.slice(-2)
            const hours = seconds / 3600
            const minutes = (seconds % 3600) / 60
            return [hours, minutes].map(format).join(':')
        },
        formatDateTime(str) {
            if(!this.safariTrue){
                var date = new Date(str);
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0'+minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                return  date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " " + strTime;
            }else{
                if(str != '' || str != null || str != undefined){
                    var date = str.slice(0,11).split("-"),
                    mnth = date[1],
                    day = date[2],
                    year = date[0],
                    time = str.slice(11,16);
                    var newDate = [day, mnth,year].join("/");
                    return newDate + " " + time
                    // const parts = str.split(/[- :]/);
                    // const wanted = parts[2] + '/' + parts[1] + '/' + parts[0] + ' ' + parts[3] + ':' + parts[4];
                    // return wanted;
                }
            }
        },
        convertFilter(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        },
        convertView(str) {
            if(!this.safariTrue){
                var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
                return [day, mnth,date.getFullYear()].join("/");
            }else{
                if(str != '' || str != null || str != undefined){
                    var date = str.slice(0,11).split("-"),
                    mnth = date[1],
                    day = date[2],
                    year = date[0],
                    time = str.slice(11,16);
                    var newDate = [day, mnth,year].join("/");
                    return newDate
                }
            }
        },
        convertViewSurvey(str) {
            console.log(str)
            if(!this.safariTrue){
                var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
                return [mnth, day,date.getFullYear()].join("/");
            }else{
                if(str != '' || str != null || str != undefined){
                    var date = str.slice(0,11).split("-"),
                    mnth = date[1],
                    day = date[2],
                    year = date[0],
                    time = str.slice(11,16);
                    var newDate = [mnth, day,year].join("/");
                    console.log(newDate)
                    return newDate
                }
            }
        },
    },
    mounted(){
        this.safariTrue = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/convert.js